import { InspectionCase } from '../inspection-cases';

export class DialContact {
  name?: string;
  phone?: string;
}
export class DialRiskLevelDto extends InspectionCase {
  dialNumber?: string;
  contacts?: DialContact[];
  checkTime?: string;
}

export class DialRiskLevel extends DialRiskLevelDto {
  constructor(
    data: DialRiskLevelDto = {
      isApplicable: true
    }
  ) {
    super(data);

    this.dialNumber = data.dialNumber;
    this.contacts = data.contacts ?? [{ name: '', phone: '' }];
    this.checkTime = data.checkTime;
  }

  setInspectionStatus(): void {
    this.isPassed = this.isPassed || !this.isApplicable;
  }
}
